import { useSyncExternalStore } from "react";

// The home page's opt-in 3D mode, shared by the header switch
// (components/home/ThreeDToggle) and the page (components/home/three/).
// Remembered per browser in localStorage and mirrored as `data-3d` on <html>.
// The root layout's head script applies that attribute before first paint,
// so a returning 3D visitor doesn't see the flat page flash first.

const KEY = "nohaya-3d";
const listeners = new Set<() => void>();
let enabled = false;
let ready = false;
let enabledAt = 0;

function init() {
  if (ready || typeof window === "undefined") return;
  ready = true;
  try {
    enabled = localStorage.getItem(KEY) === "1";
  } catch {
    enabled = false;
  }
  document.documentElement.toggleAttribute("data-3d", enabled);
}

function subscribe(listener: () => void) {
  init();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  init();
  return enabled;
}

function getServerSnapshot() {
  return false;
}

export function set3D(on: boolean) {
  init();
  enabled = on;
  if (on) enabledAt = performance.now();
  try {
    localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    // Private mode etc. -- still works for this page view.
  }
  document.documentElement.toggleAttribute("data-3d", on);
  listeners.forEach((l) => l());
}

// True right after the visitor flipped the switch on (not when 3D was
// restored from a previous visit) -- used to show the one-time hint.
export function wasJustEnabled() {
  return enabledAt > 0 && performance.now() - enabledAt < 1500;
}

export function use3DMode() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
